import { InjectionToken } from '@angular/core';
import type { Locale } from '@freelancer/config';

export const WEBAPP_LANGUAGE_COOKIE = new InjectionToken<Locale>(
  'LanguageCookie',
);
export const NATIVE_LANGUAGE_COOKIE = new InjectionToken<Locale>(
  'LanguageCookie',
);
